// @flow
import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import './styles.scss'
import CopyrightNotice from '@ta-interaktiv/react-copyright-notice'
import FeedbackMessage from '@ta-interaktiv/react-feedback-message'
import ShareButtons from '@ta-interaktiv/react-share-buttons'
import { TimestampFormatter } from '@ta-interaktiv/react-publication-info'

type Props = {
  articleId: string,
  publicationDate: number
}

export function Footer ({ articleId, publicationDate }: Props) {
  return (
    <footer className='ui vertical padded grey segment ta footer'>
      <div className='ui container'>
        <div className='ui grid'>
          <div className='two column stackable row'>
            <div className='column'>
              <table className='ui small very basic definition infographic unstackable table'>
                <tbody>
                  <tr>
                    <td>Texte</td>
                    <td>
                      <div className='ui list'>
                        <div className={'item'}>Cathy Macherel</div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Cartes</td>
                    <td>Cathy Macherel et Duc-Quang Nguyen</td>
                  </tr>
                  <tr>
                    <td>Illustrations</td>
                    <td>Adriano Fagioli</td>
                  </tr>
                  <tr>
                    <td>Publié le</td>
                    <td>
                      <TimestampFormatter timestamp={publicationDate} />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className='column'>
              <FeedbackMessage
                question='Vous voulez communiquer un renseignement ou vous avez repéré une erreur?'
                call='Envoyez-nous un message à '
                project='L’ancrage des populismes en Europe'
                mailTo='tg.web@tdg.ch'
              />

              <ShareButtons className='basic' articleId={articleId} />
            </div>
          </div>

          <div className='two column stackable row'>
            <div className='column'>
              <CopyrightNotice year={'2018'} inverted={false} />
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
